// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Icon,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
// import DataTable from "theme/Tables/DataTable";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";
import QRCode from "react-qr-code";

import ApiConfig from "apiConfig";

// import { useMaterialUIController } from "context";
import usePageTitle from "app/pageTitle";
import CompanyNotification from "app/company_notification";

function RequestMoneyIndex() {
  const title = "Request Money";
  usePageTitle(title);

  // const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [digitalWallets, setDigitalWallets] = useState([]);
  const [selectedDigitalWallet, setSelectedDigitalWallet] = useState(null);
  const [selectedDigitalCurrency, setSelectedDigitalCurrency] = useState(null);
  const [digitalCurrenciesMain, setDigitalCurrenciesMain] = useState([]);
  const [digitalCurrencies, setDigitalCurrencies] = useState([]);
  const [fiatCurrencies, setFiatCurrencies] = useState([]);
  const [feeObjects, setFeeObjects] = useState({});
  const [exchangeRates, setExchangeRates] = useState({});
  const [calculated, setCalculated] = useState(false);
  const [commercialLine, setCommercialLine] = useState("");
  const [feeLine, setFeeLine] = useState("");
  const [rateLine, setRateLine] = useState("");
  const [requestLink, setRequestLink] = useState(null);

  const [showCompanyNotification, setShowCompanyNotification] = useState(false);
  const [companyNotification, setCompanyNotification] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("ewallets/request/money/init.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setDigitalWallets(result.data.data.wallets);
            setDigitalCurrenciesMain(result.data.data.digital_currencies);
            setFiatCurrencies(result.data.data.fiat_currencies);
            setFeeObjects(result.data.data.fees);
            setExchangeRates(result.data.data.rates);
            if (result.data.notification) {
              setCompanyNotification(result.data.notification);
              if (result.data.notification.pages.includes("ALL")) {
                setShowCompanyNotification(true);
              } else if (result.data.notification.pages.includes("dw-switch-request-money")) {
                setShowCompanyNotification(true);
              }
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again later.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  const [digitalCurrency, setDigitalCurrency] = useState("");
  const [fiatCurrency, setFiatCurrency] = useState("");
  const [state, setState] = useState({});
  const { digitalWallet = null, amount = null, memo = null } = state;

  function calculateFee(digitalWalletCode, trxAmount) {
    const feeObject = feeObjects[digitalWalletCode];
    let tFee = feeObject.fee;
    if (feeObject.is_percentage) {
      tFee = trxAmount * feeObject.fee;
      if (feeObject.minimum > 0) {
        tFee = feeObject.minimum > tFee ? feeObject.minimum : tFee;
      }

      if (feeObject.maximum > 0) {
        tFee = feeObject.maximum < tFee ? feeObject.maximum : tFee;
      }

      tFee += feeObject.mandatory_fee;
    }

    let cDiscount = feeObject.discount;
    if (feeObject.is_discount_percentage) {
      cDiscount = tFee * feeObject.discount;
    }

    tFee -= cDiscount;
    return tFee;
  }

  function showCommercials() {
    if (digitalCurrency === null || fiatCurrency === null || digitalWallet == null) {
      return;
    }

    if (amount === null) {
      return;
    }

    let cLine = "";
    const dir = "Get";
    const fee = calculateFee(
      selectedDigitalWallet.code,
      amount * exchangeRates[digitalWallet][digitalCurrency].sell
    ); // amount * 0.025;
    const amt = (amount * exchangeRates[digitalWallet][digitalCurrency].sell - fee) / 100;
    const fAmt = amt.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    if (amt <= 0) {
      setSeverity("error");
      setErrMsg("The amount is too small.");
      setOpen(true);
      return;
    }

    cLine = `You ${dir}: ${fiatCurrency} ${fAmt} apprx`;
    const feeL = `Fee: ${fiatCurrency} ${(fee / 100).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
    const rateL = `Rate: ${fiatCurrency} ${(
      exchangeRates[digitalWallet][digitalCurrency].sell / 100
    ).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} / ${digitalCurrency} 1.00`;

    setCommercialLine(cLine);
    setFeeLine(feeL);
    setRateLine(rateL);
    setCalculated(true);
  }

  const handleInputChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
    setCalculated(false);
  };

  function handleWalletChange(value) {
    setState({ ...state, digitalWallet: value });
    setDigitalCurrencies(digitalCurrenciesMain[value]);
    setCalculated(false);
    setRequestLink(null);

    digitalWallets.forEach((item) => {
      if (item.code === value) {
        setSelectedDigitalWallet(item);
      }
    });
  }

  function handleDigitalCurrencyChange(value) {
    setDigitalCurrency(value);

    digitalCurrencies.forEach((item) => {
      if (item.code === value) {
        setSelectedDigitalCurrency(item);
      }
    });
  }

  const postData = async (params) => {
    setShowLoading(true);
    const json = JSON.stringify(params);
    await axios
      .post("ewallets/request/money.json", json)
      .then((response) => {
        setShowLoading(false);
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg("Request link generated successfully");
          setOpen(true);

          setRequestLink(response.data.data.request.data.redirect_url);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg("An error occurred. Please try again later.");
        setOpen(true);
        setShowLoading(false);
      });
  };

  const handleSubmit = () => {
    if (digitalWallet === null) {
      setSeverity("error");
      setErrMsg("Please select a digital wallet");
      setOpen(true);
      return;
    }

    if (digitalCurrency === null || digitalCurrency === "") {
      setSeverity("error");
      setErrMsg("Please select a wallet currency");
      setOpen(true);
      return;
    }

    if (fiatCurrency === null || fiatCurrency === "") {
      setSeverity("error");
      setErrMsg("Please select a destination currency");
      setOpen(true);
      return;
    }

    if (amount === null || amount <= 0) {
      setSeverity("error");
      setErrMsg("Please enter a valid amount.");
      setOpen(true);
      return;
    }

    if (memo === null || memo === "") {
      setSeverity("error");
      setErrMsg("Please enter a description.");
      setOpen(true);
      return;
    }

    if (!calculated) {
      showCommercials();
      return;
    }

    const params = {
      digital_wallet: digitalWallet,
      digital_currency: digitalCurrency,
      fiat_currency: fiatCurrency,
      amount: amount * selectedDigitalCurrency.multiplier,
      memo: `${memo}`,
    };

    // console.log(params);
    postData(params);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {companyNotification !== null && showCompanyNotification ? (
        <CompanyNotification
          title={companyNotification.title}
          description={companyNotification.description}
        />
      ) : (
        <> </>
      )}
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox pt={3} pb={3}>
              <Card>
                <MDBox p={3}>
                  <MDBox>
                    <MDTypography variant="h4">Request Funds</MDTypography>
                  </MDBox>
                  <MDBox mt={1}>
                    <MDTypography variant="h6" fontWeight="light">
                      Get paid from anyone, anytime, anywhere. Request funds from family, friends
                      and business partners using any digital wallet of their choice.
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                        Request Money
                      </MDTypography>
                      <MDBox mt={5}>
                        <MDBox mb={3}>
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel>Digital Wallet</InputLabel>
                            <Select
                              label="Digital Wallet"
                              onChange={(e) => handleWalletChange(e.target.value)}
                              sx={{ padding: "10px", paddingLeft: "3px" }}
                              value={digitalWallet || ""}
                            >
                              {
                                // --> Notice below changes
                                digitalWallets.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  digitalWallets.map((record) => (
                                    <MenuItem value={record.code}>
                                      <MDBox
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="left"
                                      >
                                        <img
                                          alt=""
                                          src={`${ApiConfig.api_media_url}${record.logo}`}
                                          width="20"
                                          mr={3}
                                        />
                                        <MDBox ml={2}>{record.title}</MDBox>
                                      </MDBox>
                                    </MenuItem>
                                  ))
                              }
                            </Select>
                          </FormControl>
                        </MDBox>
                        <MDBox mt={4}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>Wallet Currency</InputLabel>
                                <Select
                                  label="Wallet Currency"
                                  onChange={(e) => handleDigitalCurrencyChange(e.target.value)}
                                  sx={{ padding: "10px", paddingLeft: "3px" }}
                                  value={digitalCurrency || ""}
                                >
                                  {
                                    // --> Notice below changes
                                    digitalCurrencies.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      digitalCurrencies.map((record) => (
                                        <MenuItem value={record.code}>{record.code}</MenuItem>
                                      ))
                                  }
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>Destination Balance</InputLabel>
                                <Select
                                  label="Destination Balance"
                                  name="fiatCurrency"
                                  sx={{ padding: "10px", paddingLeft: "3px" }}
                                  onChange={(e) => setFiatCurrency(e.target.value)}
                                  value={fiatCurrency || ""}
                                >
                                  {
                                    // --> Notice below changes
                                    fiatCurrencies.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      fiatCurrencies.map((record) => (
                                        <MenuItem value={record.currency_code}>
                                          {record.currency_code} Balance
                                        </MenuItem>
                                      ))
                                  }
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                        </MDBox>
                        <MDBox mt={4}>
                          <MDInput
                            value={amount || ""}
                            onChange={handleInputChange}
                            name="amount"
                            label={`${digitalCurrency} Amount`}
                            sx={{ minWidth: 120, width: "100%" }}
                          />
                        </MDBox>
                        <MDBox mt={4}>
                          <MDInput
                            multiline
                            rows={4}
                            maxRows={10}
                            value={memo || ""}
                            onChange={handleInputChange}
                            name="memo"
                            label="Message To Payer"
                            sx={{ minWidth: 120, width: "100%" }}
                          />
                        </MDBox>
                        {calculated ? (
                          <MDBox mt={5}>
                            <Alert severity="info" sx={{ width: "100%" }}>
                              <MDTypography variant="h6" fontWeight="light">
                                {rateLine}
                              </MDTypography>
                              <MDTypography variant="h6" fontWeight="light">
                                {feeLine}
                              </MDTypography>
                              <MDTypography variant="h6" fontWeight="light">
                                {commercialLine}
                              </MDTypography>
                            </Alert>
                          </MDBox>
                        ) : (
                          <> </>
                        )}
                        <MDBox mt={5}>
                          <MDButton
                            variant="contained"
                            color="info"
                            sx={{ width: "100%" }}
                            onClick={handleSubmit}
                          >
                            Request Money
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                {requestLink !== null && calculated ? (
                  <MDBox sx={{ marginBottom: "35px" }}>
                    <Card>
                      <MDBox p={3}>
                        <MDBox textAlign="center">
                          <MDTypography variant="h6" fontWeight="light">
                            Request Link Generated
                          </MDTypography>
                          <MDTypography textAlign="center" mt={3}>
                            <QRCode value={requestLink != null ? requestLink : ""} size={180} />
                          </MDTypography>
                          <MDBox mt={1}>
                            <MDTypography variant="caption">
                              <a href={requestLink} target="_blank" rel="noopener noreferrer">
                                {requestLink}
                              </a>
                            </MDTypography>
                          </MDBox>
                          <MDBox mt={1}>
                            <MDButton
                              onClick={() => {
                                navigator.clipboard.writeText(requestLink);
                                setSeverity("success");
                                setErrMsg(`Link copied!`);
                                setOpen(true);
                              }}
                              size="small"
                              color="warning"
                              variant="contained"
                            >
                              <span sx={{ pl: 1, textTransform: "capitalize" }}>Copy Link</span>
                              &nbsp;
                              <Icon>copy</Icon>
                            </MDButton>
                          </MDBox>
                          <MDBox mt={1}>
                            <MDTypography variant="caption">
                              Share the request link with anyone to receive money instantly and
                              securely.
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                ) : (
                  <> </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default RequestMoneyIndex;
